var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89377 6.30565C9.19717 6.25257 9.41853 5.98912 9.41853 5.68111V1.20688C9.41853 1.02625 9.41876 0.888491 9.42142 0.779815C9.50566 0.848524 9.61039 0.938003 9.74755 1.05556L18.5712 8.61871C18.6476 8.6842 18.7034 8.73224 18.7457 8.77003C18.7034 8.80783 18.6476 8.85587 18.5712 8.92136L9.74755 16.4845C9.61039 16.6021 9.50566 16.6915 9.42141 16.7603C9.41876 16.6516 9.41853 16.5138 9.41853 16.3332V11.9685C9.41853 11.7929 9.3457 11.6251 9.21739 11.5053C9.08909 11.3854 8.9168 11.324 8.74159 11.3359C7.15977 11.4432 5.61071 11.8504 4.17773 12.5379C3.06664 13.0709 2.04327 13.7638 1.13909 14.592C1.34886 12.6379 2.16515 10.7888 3.48606 9.31121C4.9032 7.72596 6.81018 6.67017 8.89377 6.30565Z",
    fill: "white",
    stroke: "#1570EF",
    strokeWidth: 1.26806,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.88970d491f081750faa5c0dff1227cbf.svg";
export { ForwardRef as ReactComponent };